function base64UrlDecode(str) {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  while (str.length % 4) str += "=";
  if (typeof atob === "function") {
    return decodeURIComponent(escape(atob(str)));
  }
  return Buffer.from(str, "base64").toString("utf8");
}

/**
 * Decode JWT payload (no signature verification).
 * Adds expDates when `exp` is present (epoch seconds per JWT spec).
 */
export function getJwtPayload(token) {
  const parts = token?.split(".");
  if (parts.length < 2) throw new Error("Invalid token");

  const payload = JSON.parse(base64UrlDecode(parts[1]));

  const expSec = Number(payload.exp);
  if (Number.isFinite(expSec)) {
    const expDate = new Date(expSec * 1000);
    payload.expDates = {
      utc: expDate.toISOString(),
      local: expDate.toString(),
    };
  }

  return payload;
}
